import { Box, Heading, Text, Link } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { IUser } from "../../model";

export const Hosted = ({ data }: { data: IUser }) => {
  const { t } = useTranslation();
  return (
    <Box
      w={{ base: "100%", md: "30%" }}
      textAlign={{ base: "center", md: "left" }}
    >
      <Heading
        as="h3"
        fontSize="24px"
        mb="15px"
        textAlign="center"
        // color="#6AF6FF"  // Brand color for heading
      >
        {t("Event hosted")}
      </Heading>
      <Box mt="20px">
        <Text fontSize="18px" color="#333">
          {data?.userName || "eventeam"}
        </Text>

      </Box>
    </Box>
  );
};
